<template>
  <div>
    <div class="rounded-lg border relative">
      <div class="bg-gray-100 px-2.5 py-2.5 uppercase">Coupon Code</div>
      <div class="px-2.5 py-2.5 border-b">
        <button class="border-custom px-2.5 py-2.5 text-blue-500 w-1/3 rounded-lg" @click="openNewModal">+ Add
          new</button>
      </div>
      <t-modal ref="addCouponCodeModal">
        <div class="text-sm flex-col text-left mb-3">
          <label class="text-gray-600 text-sm font-semibold my-3 block">Coupon Prefix</label>
          <input type="text" class="rounded-lg mb-1 w-full uppercase" 
          :class="{
          'bg-gray-300 pointer-events-none ': isPrefixSet,
          'bg-gray-300 pointer-events-none': mode === 'edit'
          }"
           :readonly="isPrefixSet" 
          placeholder="e.g.: MDRSDP" :disabled="mode === 'edit'" :value="computedCouponPrefix"
          @input="updatePrefix($event.target.value)" />

          <p class="text-xs text-gray-500">Max 6 characters and must be unique.</p>

          <label class="text-gray-600 text-sm font-semibold mt-2 block">Number of Coupons</label>
          <input type="number" class="rounded-lg mb-4 w-full" placeholder="e.g.: 50" v-model="numberCoupon" />
        </div>

        <div class="flex justify-center">
          <button class="bg-blue-700 py-2.5 px-2.5 w-full text-white rounded-lg" @click="saveCode">
            Save
          </button>
        </div>
      </t-modal>
      <div v-if="!isEditMode">
        <div v-if="form.couponCodes.length" class="mt-4 px-2.5 py-2.5">
          <ul>
            <li v-for="(coupon, index) in form.couponCodes" :key="index"
              class="text-gray-800 text-sm border w-1/3 px-2.5 py-2.5 mb-2.5 rounded-lg bg-gray-100 relative">
              {{ coupon }}
          
            </li>
          </ul>
        </div>
        <div v-else>
          <div class="flex-col items-center justify-center flex-nowrap flex h-96">
            <svg class="w-14 h-14 text-gray-500 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M10 3v4a1 1 0 0 1-1 1H5m4 8h6m-6-4h6m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z" />
            </svg>
            <h4 class="text-base text-gray-600 mb-0">No Data</h4>
            <p class="text-sm text-gray-500">There are no data to display</p>
          </div>
        </div>
      </div>
      <div v-if="isEditMode">
        <div v-if="form.couponCodes.length" class="mt-4 px-2.5 py-2.5">
          <ul>
            <li v-for="(coupon, index) in form.couponCodes" :key="index"
              class="text-gray-800 text-sm border w-1/3 px-2.5 py-2.5 mb-2.5 rounded-lg bg-gray-100 relative uppercase">
              {{ coupon.code }}
            </li>
          </ul>
        </div>
        <div v-else>
          <div class="flex-col items-center justify-center flex-nowrap flex h-96">
            <svg class="w-14 h-14 text-gray-500 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M10 3v4a1 1 0 0 1-1 1H5m4 8h6m-6-4h6m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z" />
            </svg>
            <h4 class="text-base text-gray-600 mb-0">No Data</h4>
            <p class="text-sm text-gray-500">There are no data to display</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "CouponCode",
  props: {
    form: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
    },
    mode: {
      type: String,
      default: "create",
    },
  },
  data() {
    return {
      couponPrefix: "",
      numberCoupon: "",
      couponCodes: [],
      isPrefixSet: false,
    };
  },
  watch: {
    'form.couponCodes': {
      handler(newVal) {
        if (this.isEditMode) {
          this.form.couponCodes = newVal
        } else {
          this.couponCodes = [];
        }
      },
      immediate: true
    },
    'form.couponPrefix': {
      handler(newVal) {
        if (this.isEditMode) {
          this.couponPrefix = newVal;
        }
      },
      immediate: true
    }
  },
  created() {
    if (this.isEditMode) {
      this.couponPrefix = this.couponPrefix || "";
    }
  },
  computed: {
    isEditMode() {
      return this.mode === 'edit';
    },
    computedCouponPrefix: {
      get() {
        return this.isEditMode ? this.form.couponPrefix : this.couponPrefix;
      },
      set(value) {
        if (this.isEditMode) {
          this.form.couponPrefix = value;
        } else {
          this.couponPrefix = value;
        }
      }
    }
  },

  methods: {
    generateCouponCode(prefix) {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
      let randomString = '';
      for (let i = 0; i < 6; i++) {
        randomString += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      return `${prefix}${randomString}`;
    },

    saveCode() {
      if (this.mode === 'create') {
        if (!this.couponPrefix || this.couponPrefix.length > 6) {
          alert("Coupon prefix is required and must not exceed 6 characters.");
          return;
        }

      }

      if (!this.numberCoupon || this.numberCoupon <= 0) {
        alert("Please enter a valid number of coupons.");
        return;
      }

      if (!this.isPrefixSet) {
        this.isPrefixSet = true;
      }

      for (let i = 0; i < this.numberCoupon; i++) {
        if (this.mode === 'create') {
          const couponCode = this.generateCouponCode(this.couponPrefix);

          this.couponCodes.push(couponCode)
          this.$emit("update-coupons", couponCode);
        }
        if (this.mode === 'edit') {
          const couponCode = this.generateCouponCode(this.form.couponPrefix.trim());
          this.form.couponCodes.push({ code: couponCode });
        }

      }
      this.numberCoupon = "";
      this.$refs.addCouponCodeModal.hide();
    },
    updatePrefix(value) {
      this.computedCouponPrefix = value.toUpperCase();
      this.$emit('update-coupon-prefix', this.couponPrefix.toUpperCase());
    },
    openNewModal() {
      this.$refs.addCouponCodeModal.show();
      if (this.mode === 'create') {
        if (this.isPrefixSet) {
        this.couponPrefix = this.couponPrefix || "";
      } else {
        this.couponPrefix = '';
      }
      this.numberCoupon = "";
      }
      
    },
  },
};
</script>

<style scoped>
.border-custom {
  border: 1px solid #3b82f6 !important;
}
</style>
